import React from 'react';
import {
  Box,
  Container,
  Paper,
  Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

const LOGO_URL = 'https://media.creditpulse.com/branding/credit-pulse-banner-logo-transparent.png';

interface Props {
  children: React.ReactNode;
  showFooter?: boolean;
}

export const PublicPageLayout: React.FC<Props> = ({ children, showFooter = false }) => {
  const { t } = useTranslation('components', { keyPrefix: 'page-shell' });

  return (
    <Box
      sx={{
        alignItems: 'center',
        backgroundColor: '#f0f1f5',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        minHeight: '100vh',
        px: 2,
        py: 6,
      }}
    >
      <Container maxWidth='sm'>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            mb: 4,
          }}
        >
          <img
            alt='Credit Pulse'
            src={LOGO_URL}
            style={{
              height: 48,
              objectFit: 'contain',
            }}
          />
        </Box>
        <Paper
          elevation={0}
          sx={{
            borderRadius: 3,
            overflow: 'hidden',
          }}
        >
          {children}
          {showFooter && (
            <Box
              sx={{
                borderTop: '1px solid',
                borderColor: 'divider',
                px: 5,
                py: 2,
                backgroundColor: '#444',
              }}
            >
              <Typography
                color='white'
                fontWeight={700}
                variant='body2'
              >
                {t('footer_message')}
              </Typography>
            </Box>
          )}
        </Paper>
        <Typography
          color='text.secondary'
          sx={{
            display: 'block',
            mt: 3,
            textAlign: 'center',
          }}
          variant='caption'
        >
          {t('powered_by')}
          &nbsp;
          <a
            href='https://www.creditpulse.com'
            rel='noopener noreferrer'
            target='_blank'
          >
            Credit Pulse
          </a>
          &nbsp;&mdash;
          {' '}
          {t('confidential')}
        </Typography>
      </Container>
    </Box>
  );
};
